module.exports = __webpack_public_path__ + "static/img/jurassic_warn@2x.cd244f48.png";